var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import BreakInDamageCheckBox from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageCheckBox.vue';
import BreakInDamageDescriptionSubSection from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSubSection.vue';
import { parseLength } from '@declaration/helpers/typeFormatters';
import BreakInDamageChoices from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageChoices.vue';
import { FRENCH_WINDOW_HEIGHT_CHOICES, FRENCH_WINDOW_ONE_LEAF_WIDTH_CHOICES, FRENCH_WINDOW_TWO_LEAVES_WIDTH_CHOICES, } from '@shared/constants/breakInDamages/FrenchWindowConstants';
import { LeavesType } from '@shared/types/api/breakInDamage';
import { GLASS_TYPE_TRAD_KEYS_AND_IMAGES, GLAZING_TYPE_TRAD_KEYS_AND_IMAGES, } from '@shared/constants/breakInDamageConstants';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let FrenchWindowSizeAndGlazing = class FrenchWindowSizeAndGlazing extends Vue {
    constructor() {
        super(...arguments);
        this.parseLength = parseLength;
        this.isSaving = false;
        this.showValidation = false;
        this.FRENCH_WINDOW_HEIGHT_CHOICES = FRENCH_WINDOW_HEIGHT_CHOICES;
        this.glazingTypes = Object.entries(GLAZING_TYPE_TRAD_KEYS_AND_IMAGES).map(([glazingType, description]) => ({
            value: glazingType,
            tradKey: description.tradKey,
            image: description.image,
        }));
        this.glassTypes = Object.entries(GLASS_TYPE_TRAD_KEYS_AND_IMAGES).map(([glassType, description]) => ({
            value: glassType,
            tradKey: description.tradKey,
            image: description.image,
        }));
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        return (!this.validation.fieldHasViolations('frenchWindowHeight') &&
            !this.validation.fieldHasViolations('frenchWindowWidth') &&
            !this.validation.fieldHasViolations('frenchWindowGlazingType') &&
            !this.validation.fieldHasViolations('frenchWindowLaminatedGlazingType'));
    }
    get widthValues() {
        let widthValues;
        this.breakInDamage.frenchWindowType === LeavesType.OneLeaf
            ? (widthValues = FRENCH_WINDOW_ONE_LEAF_WIDTH_CHOICES)
            : (widthValues = FRENCH_WINDOW_TWO_LEAVES_WIDTH_CHOICES);
        return widthValues;
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.isSaving = true;
        this.$emit('goToNextStep');
        this.isSaving = false;
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
};
__decorate([
    layout.State('color')
], FrenchWindowSizeAndGlazing.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], FrenchWindowSizeAndGlazing.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], FrenchWindowSizeAndGlazing.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], FrenchWindowSizeAndGlazing.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], FrenchWindowSizeAndGlazing.prototype, "validateBreakInDamage", void 0);
FrenchWindowSizeAndGlazing = __decorate([
    Component({
        components: {
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            RadioPrimaryButton,
            BreakInDamageCheckBox,
            BreakInDamageDescriptionSubSection,
            BreakInDamageChoices,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
        },
    })
], FrenchWindowSizeAndGlazing);
export default FrenchWindowSizeAndGlazing;
